import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight, FaSearchPlus, FaTimes, FaFilePdf } from 'react-icons/fa';
import Navbar from '../../components/Navbar/NavBar';

// Import product images
import img1 from '../../images/products/M1_P7.1.png';
import img2 from '../../images/products/M1_P7.2.png';
import img3 from '../../images/products/M1_P7.3.png';
import img4 from '../../images/products/M1_P7.4.png';

// Import product PDF
import productPDF from '../../Manuals/P7.pdf';

const Product7 = () => {
  const navigate = useNavigate();
  const [currentImage, setCurrentImage] = useState(0);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  const images = [img1, img2, img3, img4];

  useEffect(() => {
      window.scrollTo(0, 0);
  }, []);

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <>
      <Navbar />

      <div className="min-h-screen bg-gray-100 flex flex-col items-center pt-24 p-6">
        {/* Product Title */}
        <h1 className="text-7xl font-extrabold text-blue-900 mb-12 text-center" style={{ fontFamily: 'Congenial Black' }}>
          Temperature and RH Controller
        </h1>

        <div className="flex flex-col sm:flex-row items-start w-full max-w-6xl">
          {/* Image Carousel */}
          <div className="relative w-[500px] flex flex-col items-center">
            <div className="relative w-full">
              <button 
                className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-gray-700 text-white p-2 rounded-full transition hover:bg-gray-900" 
                onClick={prevImage}
              >
                <FaArrowLeft />
              </button>

              <img 
                src={images[currentImage]} 
                alt="RIZM TR-71 Temperature and RH Controller" 
                className="w-full rounded-lg shadow-lg cursor-pointer"
              />

              <button 
                className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-gray-700 text-white p-2 rounded-full transition hover:bg-gray-900" 
                onClick={nextImage}
              >
                <FaArrowRight />
              </button>

              {/* Magnify Button */}
              <button 
                className="absolute top-2 right-2 bg-gray-700 text-white p-2 rounded-full transition hover:bg-gray-900"
                onClick={() => setIsImageModalOpen(true)}
              >
                <FaSearchPlus />
              </button>
            </div>

            {/* PDF Button below Image */}
            <button 
              className="mt-4 px-6 py-2 bg-red-600 text-white flex items-center gap-2 rounded-lg hover:bg-red-800 transition"
              onClick={() => setIsPDFModalOpen(true)}
            >
              <FaFilePdf className="text-xl" />
              View PDF
            </button>
          </div>

          {/* Product Details */}
          <div className="ml-10 max-w-lg bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold mb-3 text-gray-800">Specifications</h2>
            <ul className="list-disc list-inside text-gray-700">
              <li><strong>Model Name/Number:</strong> RIZM TR-71</li>
              <li><strong>Usage/Application:</strong> Pharmaceutical Industries</li>
              <li><strong>Type:</strong> Automatic</li>
              <li><strong>Power Consumption:</strong> 730 Watt</li>
              <li><strong>Relative Humidity:</strong> 55%</li>
              <li><strong>Brand:</strong> Gravity Techno</li>
              <li><strong>Voltage:</strong> 230 VAC</li>
              <li><strong>Frequency:</strong> 50 Hz</li>
              <li><strong>Power Source:</strong> Electric</li>
            </ul>
          </div>
        </div>

        <button 
          onClick={() => navigate(-1)} 
          className="mt-6 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-800 transition"
        >
          Go Back
        </button>
      </div>

      {/* Modal for Enlarged Image */}
      {isImageModalOpen && (
        <div 
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-75 flex justify-center items-center z-50"
          onClick={() => setIsImageModalOpen(false)}
        >
          <div className="relative max-w-3xl">
            <img 
              src={images[currentImage]} 
              alt="RIZM TR-71 Enlarged" 
              className="w-full rounded-lg"
            />
            <button 
              className="absolute top-3 right-3 bg-gray-700 text-white p-2 rounded-full transition hover:bg-gray-900"
              onClick={() => setIsImageModalOpen(false)}
            >
              <FaTimes />
            </button>
          </div>
        </div>
      )}

      {/* Modal for PDF */}
      {isPDFModalOpen && (
        <div 
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-75 flex justify-center items-center z-50"
          onClick={() => setIsPDFModalOpen(false)}
        >
          <div className="relative bg-white p-4 rounded-lg w-3/4 h-3/4 shadow-lg flex flex-col">
            <button 
              className="absolute top-3 right-3 bg-gray-700 text-white p-2 rounded-full transition hover:bg-gray-900"
              onClick={() => setIsPDFModalOpen(false)}
            >
              <FaTimes />
            </button>
            <iframe 
              src={productPDF} 
              className="w-full h-full"
              title="Product PDF"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Product7;
